import { render, staticRenderFns } from "./RegisterPostTypeComponent.vue?vue&type=template&id=84c68aec&scoped=true"
import script from "./RegisterPostTypeComponent.vue?vue&type=script&lang=js"
export * from "./RegisterPostTypeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c68aec",
  null
  
)

export default component.exports